<div class="signature-pad-container" [ngClass]="isEmpty() ? 'empty': 'signed'">
    <div class="signature-pad-header">
        <div class="writing">Sign below!</div>
        <div [class.hidden]="isEmpty()">
            <app-button text="Clear" subStyle="white" minWidth="75" class="mb-2"
             [disabled]="readonly"
             (clicked)="clear()">
            </app-button>
        </div>
    </div>
    <canvas class="signature-pad-canvas"
    [class.read-only]="readonly"></canvas>
</div>
